// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1RnkY","title":"Header_title__25tql","side":"Header_side__1BcEa"};